import { initFederation } from '@angular-architects/native-federation';

declare global {
  interface Window {
    ngDevMode?: boolean;
  }
}

const ENV_KEY = Symbol.for('POS_ENVIRONMENT');
const environment = (globalThis as any)[ENV_KEY];

if (environment?.production || environment?.env === 'staging' || environment?.env === 'development') {
  window.ngDevMode ??= false;
}

initFederation({
  pos_mfe_core: environment?.mfeUrls?.pos_mfe_core,
})
  .catch((err) => console.error('Error inicializando Federation en Retail:', err))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error('Error arrancando Angular:', err));
